import { useState, useEffect, useRef } from "react"
import Oclock from "../common/Oclock"
import { useLayout } from "../../hooks";
import { useParams } from "react-router-dom";
import { getProject } from "../../api/project";
import { apis } from "../../constants"
import styles from './detail.module.scss';
import { Loading } from "./Layouts";
import AlarmTypesPie from "./Charts/AlarmTypesPie";
import ProjectDeviceStatusPie from "./Charts/ProjectDeviceStatusPie";
import OnlineRatioAxis from "./Charts/OnlineRatioAxis";
import Realtime, { Alarms } from "./Realtime";
import { Title } from "./Layouts";
import ProjectMap from './ProjectMap';
import { useNavigate } from "react-router-dom";

export default function Dashboard() {
    const { projectId } = useParams();
    const navigate = useNavigate();
    const [fullScreen, setFullScreen] = useState(true);
    const [loading, setLoading] = useState(false);
    const [detail, setDetail] = useState<Project>();
    const [detailLoading, setDetailLoading] = useState(false);
    const imgContainerRef = useRef<HTMLImageElement>(null);
    const [imgLoading, setImgLoading] = useState(false);
    const { width, height } = useLayout(1, 1, 0, fullScreen);
    const [refreshKey, setRefreshKey] = useState(0);
    useEffect(() => {
        setRefreshKey(new Date().getTime());
    }, [fullScreen])
    useEffect(() => {
        if (!projectId) return;
        setDetailLoading(true)
        getProject(projectId)
            .then(setDetail)
            .finally(() => {
                setDetailLoading(false)
            })
    }, [projectId])
    const imgUrl = detail?.files?.[0]?.name ? apis.getImage.replace('{filename}', detail?.files?.[0]?.name) : '';
    useEffect(() => {
        if (!imgUrl) return;
        setImgLoading(true)
        const img = new Image()
        img.src = imgUrl;
        img.alt = '平面图加载失败';
        img.className = styles.imgInner;
        img.onload = (e) => {
            if (!imgContainerRef.current) return;
            setImgLoading(false)
        }
    }, [imgUrl]);
    const layouts = {
        width,
        height,
        header: {
            width: width,
            height: height * 0.1,
        },
        rowGap: height * 0.08,
        content: {
            width: width,
            height: height * (1 - 0.1 - 0.08),
            columnGap: width * 0.01,
            center: {
                width: (1 - 0.25 - 0.02) * width,
                height: height * (1 - 0.1 - 0.01),
                rowGap: height * (1 - 0.1 - 0.01) * 0.01,
                sumamry: {
                    width: (1 - 0.25 - 0.02) * width,
                    height: height * (1 - 0.1 - 0.01) * 0.3,
                    columnGap: width * 0.01,
                },
                map: {
                    width: (1 - 0.25 - 0.02) * width,
                    height: height * (1 - 0.1 - 0.01) * 0.69,
                }
            },
            right: {
                width: 0.25 * width,
                height: height * (1 - 0.1 - 0.01),
                rowGap: height * 0.01,
                table: {
                    width: 0.25 * width,
                    height: height * (1 - 0.1 - 0.01 - 0.01) / 2,
                }
            }
        }

    }
    return (
        <section key={refreshKey} style={{
            width: layouts.width, height: layouts.height
        }} className={styles.container + ' ' + (fullScreen ? styles['full-screen'] : '')}>
            <section className={styles.header} style={{
                width: layouts.header.width,
                height: layouts.header.height,
                backgroundImage: `url("/123.png")`,
            }}>
                <div className={styles.toggler}>
                    <a className={styles.togglerLink} onClick={(e) => {
                        e.preventDefault()
                        setFullScreen(!fullScreen)
                    }}>{fullScreen ? '退出全屏' : '全屏'}</a>
                    <a className={styles.togglerLink} onClick={(e) => {
                        e.preventDefault()
                        navigate(-1)
                    }}>返回</a>
                </div>
                <div style={{
                    width: '30%'
                }}>
                    <Oclock />
                </div>
                <h2 style={{
                    color: '#fff',
                    fontSize: 20,
                    fontWeight: 600
                }}>{detail?.name}</h2>
                <div style={{
                    width: '30%',
                    display: 'flex',
                    justifyContent: 'end'
                }}>
                    <h4 style={{
                        color: '#fff'
                    }}>{detail?.startDate} - {detail?.endDate}
                    </h4>
                </div>
            </section>
            <section className={styles.content} style={{
                width: layouts.content.width,
                height: layouts.content.height,
            }}>
                <section className={styles.center} style={{
                    width: layouts.content.center.width,
                    height: layouts.content.center.height,
                }}>
                    <div className={styles.summary} style={{
                        width: layouts.content.center.sumamry.width,
                        height: layouts.content.center.sumamry.height,
                    }}>
                        <ProjectDeviceStatusPie proejct={detail} style={{
                            width: layouts.content.center.width * 0.33,
                            height: layouts.content.center.sumamry.height,
                        }} />
                        <AlarmTypesPie hideLegend round style={{
                            width: layouts.content.center.width * 0.33,
                            height: layouts.content.center.sumamry.height,
                        }} projectId={projectId} />
                        <OnlineRatioAxis projectId={projectId} style={{
                            width: layouts.content.center.width * 0.33,
                            height: layouts.content.center.sumamry.height,
                        }} />
                    </div>
                    <div className={styles.map} style={{
                        width: layouts.content.center.map.width,
                        height: layouts.content.center.map.height,
                    }}>
                        <Title>展会平面图</Title>
                        <div className={styles['img-container']}>
                            {loading ?
                                <Loading /> :
                                detail ?
                                    <ProjectMap project={detail as Project} imgUrl={imgUrl} /> : null
                            }
                        </div>
                    </div>

                </section>
                <section className={styles.right} style={{
                    width: layouts.content.right.width,
                    height: layouts.content.right.height,
                }}>
                    <div style={{
                        width: layouts.content.right.table.width,
                        height: layouts.content.right.table.height,
                    }}>
                        <Realtime fullScreen={fullScreen} projectId={projectId} />
                    </div>
                    <div style={{
                        width: layouts.content.right.table.width,
                        height: layouts.content.right.table.height,
                    }}>
                        <Alarms fullScreen={fullScreen} projectId={projectId} />
                    </div>
                </section>
            </section>
        </section>
    )
}